import { ConditionType } from '@validators/types'

export const payment: ConditionType = {
	givenName: {
		rules: ['require'],
		message: {
			require: 'Last Name is a required field.',
		},
	},
	familyName: {
		rules: ['require'],
		message: {
			require: 'First Name is a required field.',
		},
	},
	email: {
		rules: ['require', 'isEmail'],
		message: {
			require: 'Email is a required field.',
			isEmail: 'Please enter the email format in the email field.',
		},
	},
	phoneCountryCode: {
		rules: ['require'],
		message: {
			require: 'Phone Number is a required field.',
		},
	},
	phoneNumber: {
		rules: ['require'],
		message: {
			require: 'Phone Number is a required field.',
		},
	},
	countryName: {
		rules: ['require'],
		message: {
			require: 'Select country name.',
		},
	},
	states: {
		rules: ['require'],
		message: {
			require: 'State is a required field.',
		},
	},
	city: {
		rules: ['require'],
		message: {
			require: 'City is a required field.',
		},
	},
	street1: {
		rules: ['require'],
		message: {
			require: 'Street1 is a required field.',
		},
	},
	zip: {
		rules: ['require'],
		message: {
			require: 'ZIP code (Postal Code) is a required field.',
		},
	},
	cardNumber: {
		rules: ['require'],
		message: {
			require: 'Card Number is a required field.',
		},
	},
	expiredMonth: {
		rules: ['require'],
		message: {
			require: 'Expiration Date is a required field.',
		},
	},
	expiredYear: {
		rules: ['require'],
		message: {
			require: 'Expiration Date is a required field.',
		},
	},
	cvc: {
		rules: ['require'],
		message: {
			require: 'CVC is a required field.',
		},
	},
	cardName: {
		rules: ['require'],
		message: {
			require: 'Card Name is a required field.',
		},
	},

	// shipping
	deliveryCompanyName: {
		rules: ['require'],
		message: {
			require: 'No delivery company has been selected. Please choose a delivery service.',
		},
	},
}
